<div class="wccard p-3 mb-1">
    <app-talent-insights-ai  [requestaidata]="profiledataai" [insightstabname]="'profiles'" [totalcount]="totalresultcount"></app-talent-insights-ai>
</div>
<div class="fusion-chart">
    <div class="exp">
        <span class="d-flex flex-row justify-content-start mb-3">
            <span class="f-16 font-weight-600 ">Years of Experience</span>
            <span class="d-flex justify-content-between align-items-center">
                <div class="ml-2" *ngIf="isCandidateInRange">
                    <select data-testid="auto-app-report-profiles-select-1" name="" class="newSelectInput" id="" (change)="getExperienceType($event)"
                        [(ngModel)]="experienceType">
                        <option value="totalyearsofexperience">Overall</option>
                        <option value="averageyearsofexperience">Average</option>
                    </select>
                </div>
            </span>
        </span>
        <span class="d-flex flex-row">
            <div class="yoe-total-average">
                <p *ngIf="isCandidateInRange" class="f-12 font-weight-normal text-9696 "> {{selectedExperience | titlecase}} Tenure </p>
                <div class="loader d-flex justify-content-center">
                    <div class="loader text-center" *ngIf="!apiCalledExperience">
                        <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                    </div>
                    <div *ngIf="apiCalledExperience && !isCandidateInRange">
                        <p class="text-center small p-5">No Data Available</p>
                    </div>
                </div>
                <fusioncharts width="280" type="column2d" [dataSource]="dataSourceYearsOfExperience"
                    *ngIf="isCandidateInRange && dataSourceYearsOfExperience && dataSourceYearsOfExperience?.data?.length">
                </fusioncharts>
            </div>

            <span class="yoe-dash"></span>
            <div class="yoe-current">
                <p *ngIf="isCandidateInRangeCurrent" class="f-12 font-weight-normal text-9696 "> Current </p>
                <div class="loader d-flex justify-content-center">
                    <div class="loader text-center" *ngIf="!apiCalledExperienceCurrent">
                        <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                    </div>
                    <div *ngIf="apiCalledExperienceCurrent && !isCandidateInRangeCurrent">
                        <p class="text-center small p-5">No Data Available</p>
                    </div>
                </div>
                <fusioncharts class="yoe-current-fc" width="280" type="column2d" [dataSource]="dataSourceYearsOfExperienceCurrent"
                    *ngIf="isCandidateInRangeCurrent && dataSourceYearsOfExperienceCurrent && dataSourceYearsOfExperienceCurrent?.data?.length">
                </fusioncharts>
            </div>
        </span>
    </div>

    <div class="senior">
        <p class="f-16 font-weight-600 ">Seniority</p>
        <div class="loader d-flex justify-content-center chart" *ngIf="!seniorityData?.data?.length">
            <div style="min-width: 280px;" class="loader text-center" *ngIf="!apiCalledSeniority">
                <img  src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
            </div>
            <div *ngIf="apiCalledSeniority">
                <p class="text-center small p-5">No Data Available</p>
            </div>
        </div>
        <div class="senior-chart">
            <fusioncharts type="doughnut2d" [dataSource]="seniorityData"
            *ngIf="seniorityData?.data?.length" width="280" height= '300'>
        </fusioncharts>
        </div>
    </div>

</div>

<div class="col position-relative wccard mt-2 mb-1" *ngIf="continentselected != 'europe'">
    <p class="f-16 font-weight-600 pt-4">Sample Profiles</p>

    <div class="loader d-flex justify-content-center" *ngIf="!profileData.length">
        <div class="loader text-center" *ngIf="!apiCalledProfile">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div *ngIf="apiCalledProfile">
            <p class="text-center small p-5">No Data Available</p>
        </div>
    </div>

    <div class="d-flex flex-wrap">
        <div class="col-4 mb-2 pl-0 pr-2" *ngFor="let element of profileData; let i = index">
            <div class="attritionCard">
                <div>
                    <!-- <div class="profilepic">
                <i class="fa-solid fa-user"></i>
            </div> -->
                    <div>
                        <div class="circular-img mr-3 mb-3 text-capitalize" [ngClass]="{
                    'lavender-circle': i % 4 == 0,
                    'yellow-circle': i % 4 == 1,
                    'blue-circle': i % 4 == 2,
                    'teal-circle': i % 4 == 3
                  }">{{transform(element?.full_name).charAt(0)}}</div>
                    </div>
                </div>
                <div>
                    <p class="f-14 font-weight-600 mb-1 d-grid" *ngIf="element?.full_name">
                        <span class="text-truncate" [matTooltip]="element?.full_name | titlecase"
                            [matTooltipClass]="{ 'red-tooltip text-black': true }">{{element?.full_name |
                            titlecase}}</span>
                    </p>
                    <p class="f-14 mb-1 d-grid" *ngIf="element?.job_title">
                        <span class="text-truncate" [matTooltip]="element.job_title | titlecase"
                            [matTooltipClass]="{ 'red-tooltip text-black': true }">{{element?.job_title |
                            titlecase}}</span>
                    </p>
                    <div class="f-12 text-9696 d-flex align-items-center">
                        <span class="d-flex align-items-baseline" *ngIf="element.currentLocation">
                            <i class="fa-regular fa-location-dot mr-1"></i>
                            <div class="d-grid">
                                <span class="text-truncate" [matTooltip]="element.currentLocation | titlecase"
                                    [matTooltipClass]="{ 'red-tooltip text-black': true }">
                                    {{element.currentLocation | titlecase}}
                                </span>
                            </div>
                        </span>
                        <i class="fa-solid fa-circle mx-2" style="font-size:3px; color: #d9d9d9; margin-top: 0px;"
                            *ngIf="element.currentLocation && (element?.linkedin_url || element?.twitter_url || element?.facebook_url)"></i>
                        <span class="d-flex" style="width: 55px;">
                            <a data-testid="auto-app-report-profiles-a-1" target="_blank" rel="noopener noreferrer"
                                *ngIf="element?.linkedin_url && !isBoolean(element?.linkedin_url)"
                                (click)="openUrl(element?.linkedin_url, 'linkedin')"><i
                                    class="fab fa-linkedin"></i></a>
                            <a data-testid="auto-app-report-profiles-a-2" target="_blank" rel="noopener noreferrer"
                                *ngIf="element?.twitter_url && !isBoolean(element?.twitter_url)"
                                (click)="openUrl(element?.twitter_url, 'twitter')"><i
                                    class="fa-brands fa-square-x-twitter mx-2"></i></a>
                            <a data-testid="auto-app-report-profiles-a-3" target="_blank" rel="noopener noreferrer"
                                *ngIf="element?.facebook_url && !isBoolean(element?.facebook_url)"
                                (click)="openUrl(element?.facebook_url, 'facebook')"><i
                                    class="fab fa-facebook"></i></a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCount > 10">
    <ngb-pagination [collectionSize]="50" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize" rotate="false" (pageChange)="setPage($event)" [(page)]="currentPage" [ellipses]="false" [boundaryLinks]="false" [directionLinks]="false">
    </ngb-pagination>
</div>
